<div class="modal-footer">
  <ng-content></ng-content>
</div>
